.input-container {
  width: 100%;
}

.label {
  font-size: 1.4rem;
  font-weight: 400;
  line-height: normal;
  color: var(--color-grayscale-white);
  margin-bottom: 0.8rem;
}
